export default __webpack_public_path__ + "1b89253f165cc5ac32fa18335d39c6d5.css";